// gatsby-browser.js
// Import the component at the top of the file
import React from 'react'
import PageContext from './src/components/PageContext';

export const wrapRootElement = PageContext;

export const onClientEntry = () => {
	if (document.getElementById('mcjs')) return

	const script = document.createElement('script')
	script.id = 'mcjs'
	script.async = true
	script.src = 'https://chimpstatic.com/mcjs-connected/js/users/76b97b9ca5ebc4a83ae913b21/ddb218af8529955f8e5f60d56.js'
	document.head.appendChild(script)
}
